import React from 'react';

interface ICarIconProps {
	size?: string;
	className?: string;
}

export const CarIcon = ({ size = '24', className }: ICarIconProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
			<path
				d="M18 18.2261C18.5967 18.2261 19.169 17.989 19.591 17.5671C20.0129 17.1451 20.25 16.5728 20.25 15.9761C20.25 15.3793 20.0129 14.807 19.591 14.3851C19.169 13.9631 18.5967 13.7261 18 13.7261C17.4033 13.7261 16.831 13.9631 16.409 14.3851C15.9871 14.807 15.75 15.3793 15.75 15.9761C15.75 16.5728 15.9871 17.1451 16.409 17.5671C16.831 17.989 17.4033 18.2261 18 18.2261Z"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path
				d="M5.25036 18.2264C5.8471 18.2264 6.4194 17.9894 6.84135 17.5674C7.26331 17.1455 7.50036 16.5732 7.50036 15.9764C7.51084 15.6781 7.45981 15.3809 7.35044 15.1032C7.24108 14.8254 7.07572 14.5732 6.86466 14.3621C6.6536 14.1511 6.40136 13.9857 6.12364 13.8764C5.84592 13.767 5.54866 13.716 5.25036 13.7264C4.95207 13.716 4.65481 13.767 4.37709 13.8764C4.09936 13.9857 3.84712 14.1511 3.63607 14.3621C3.42501 14.5732 3.25965 14.8254 3.15029 15.1032C3.04092 15.3809 2.98989 15.6781 3.00036 15.9764C3.00036 16.5732 3.23742 17.1455 3.65937 17.5674C4.08133 17.9894 4.65363 18.2264 5.25036 18.2264V18.2264Z"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path
				d="M3 16.2761C3 16.2761 0.75 17.0261 0.75 14.7761V10.2761H12.45C14.1 10.2761 15.975 9.60107 17.025 9.60107L22.125 10.2761C22.4303 10.3274 22.7086 10.4821 22.9135 10.7142C23.1183 10.9463 23.2371 11.2418 23.25 11.5511V14.7761C23.25 15.0744 23.1315 15.3606 22.9205 15.5716C22.7095 15.7825 21.9811 16.0979 21.6828 16.0979L20.3894 16.2295"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path d="M15.7504 16.2764L7.84375 16.2764" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
			<path
				d="M17.0163 9.40962L15.2247 6.60124C15.0802 6.35098 14.8725 6.14306 14.6225 5.99828C14.3724 5.8535 14.0887 5.77693 13.7997 5.77624H3.67469C3.46967 5.76067 3.26497 5.81031 3.08986 5.91807C2.91474 6.02583 2.77818 6.1862 2.69969 6.37624L0.967799 9.84074"
				stroke="#3D3D3D"
				strokeLinecap="square"
				strokeLinejoin="round"
			/>
			<path d="M6.375 5.77637V10.2764" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
			<path d="M10.875 5.77637V10.2764" stroke="#3D3D3D" strokeLinecap="square" strokeLinejoin="round" />
			<path d="M21.75 12.5264H22.8" stroke="#121212" strokeLinecap="square" strokeLinejoin="round" />
			<path d="M2.25 12.5264H0.75" stroke="#121212" strokeLinecap="square" strokeLinejoin="round" />
		</svg>
	);
};
